import DocumentLayout from "./DocumentLayout"
import RecipientBlock from "./RecipientBlock"
import SubjectIntro from "./SubjectIntro"
import DetailRowsTable from "./DetailRowsTable"
import LetterDetails from "./LetterDetails"
import BoxDetailsGrid from "./BoxDetailsGrid"
import ClosingParagraphs from "./ClosingParagraphs"
import SignatoryFooter from "./SignatoryFooter"
import useQuotationPreviewModel from "./useQuotationPreviewModel"
import QuotationPreviewSkeleton from "./QuotationPreviewSkeleton"

const renderDetails = (layout, rows) => {
  if (layout === "letter") return <LetterDetails rows={rows} />
  if (layout === "box") return <BoxDetailsGrid rows={rows} />
  return <DetailRowsTable rows={rows} />
}

const QuotationPdfPreview = ({ quotation = {}, isLoading = false }) => {
  const model = useQuotationPreviewModel(quotation)

  if (isLoading) {
    return <QuotationPreviewSkeleton />
  }

  return (
    <DocumentLayout
      documentTitle={model.documentTitle}
      metaRows={model.metaRows}
      padLayout={model.padLayout}
    >
      <RecipientBlock lines={model.recipientLines} />
      <SubjectIntro subject={model.subject} intro={model.introText} />
      {renderDetails(model.padLayout, model.detailRows)}
      <ClosingParagraphs paragraphs={model.closingParagraphs} />
      <SignatoryFooter
        signatoryName={model.signatoryName}
        signatoryDesignation={model.signatoryDesignation}
        acceptanceLabel={model.customerSignatureLabel}
      />
    </DocumentLayout>
  )
}

export default QuotationPdfPreview
